import React from "react";
import {View, Text, StyleSheet, TextInput , BackHandler} from 'react-native';
import {RFValue} from "react-native-responsive-fontsize";
import ExamImage from "../Components/ExamImage";
import Examvideo from "../Components/Examvideo";
import Examtext from "../Components/Examtext";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Config from "../../Config";
import Toast from "../Components/Toast";
import Loading from "../Components/Loading";

const StartPlacement = ({navigation,route})=>{



    React.useEffect(() => {
        const backAction = () => {
            // Example: Show an alert to confirm exit

            Toast('لطفا آزمون را به پایان برسانید !')
            return true;
        };

        const backHandler = BackHandler.addEventListener(
            'hardwareBackPress',
            backAction
        );

        // Cleanup the event listener on component unmount
        return () => backHandler.remove();
    }, []);






    let [data, setData] = React.useState(false);


    let [number, setNumber] = React.useState(1);

    let [results, setResults] = React.useState([]);

    let[total, setTotal] = React.useState(10);

    let percent = number*100 / total;





    let finish = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');


            let formData = new FormData();
            formData.append('results', JSON.stringify(results));

            let resss = await axios.post(
                `${Config.api}/user/finisheplacement/${data.exam.id}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": 'Bearer '+token
                    }
                }
            );



            if(resss.data.code != 1){
                alert(JSON.stringify(resss.data));
                // console.log(res.data.data);
                Toast(resss.data.error);
            }
            navigation.reset({
                index: 0,
                routes: [{
                    name: "Placementresult",
                    params: { exam:   JSON.stringify(resss.data.exam) ,placement : JSON.stringify(resss.data.placement)   } // ارسال پارامترها
                }],
            });



        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }


    React.useEffect(() => {
        getData();
    },[]);
    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/startplacement`,{ 'headers': {  Authorization: 'Bearer '+token} });
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));


                Toast(res.data.error);
                navigation.goBack();
            }else{
                console.log(res.data.questions);
                // console.log('');
                setTotal(res.data.questions.length);
                setData( res.data);
            }





        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }


    if(number > total){
        setTimeout(function(){
            finish()
        },50)
    }


    return (
        <View style={styles.container}>
            {data ?
                <>
                    <View style={styles.header}>
                        <View style={styles.slider}>
                            <View style={{
                                height : RFValue(10),
                                backgroundColor : '#33B300',
                                width: `${percent}%`,
                                borderRadius : RFValue(20),
                            }}></View>
                        </View>
                        <Text style={styles.slidertxt}>{number}/{total}</Text>
                    </View>
                    <View style={styles.body}>

                        {data.questions.map( (item,index)=>
                            <React.Fragment key={index}>
                                {(index + 1) == number &&
                                    <>
                                        {item.awnser_type === 1 &&
                                            <>
                                                {item.type === 1 ?
                                                    <ExamImage key={index} question={item} setNumber={setNumber} setResults={setResults} />
                                                    :
                                                    <Examvideo key={index}  question={item} setNumber={setNumber} setResults={setResults} />
                                                }
                                            </>
                                        }
                                        {item.awnser_type === 2 &&
                                            <Examtext key={index}  question={item} setNumber={setNumber} setResults={setResults}/>
                                        }
                                    </>

                                }
                            </React.Fragment>


                        )}



                        {/*<Text> {JSON.stringify(results)}</Text>*/}
                    </View>
                </>
                :
                <Loading/>

            }


        </View>
    );
}

const styles = StyleSheet.create({

    body : {
        flex: 1,
        paddingVertical: RFValue(5),
        paddingHorizontal: RFValue(20),
    },
    container:{
        flex : 1,
        backgroundColor:'#FAFAFA',
    },
    slidertxt : {
        fontFamily : 'yk',
        fontSize : RFValue('16'),
    },
    header : {
        flexDirection: 'row',
        justifyContent:'space-between',
        alignItems:'center',
        paddingVertical: RFValue(10),
        paddingHorizontal: RFValue(20),
    },
    slider : {
        height : RFValue(10),
        backgroundColor : '#E7E7E7',
        width: '85%',
        borderRadius : RFValue(20),
    },

});

export default StartPlacement;